export default "__VITE_ASSET__YH5fkJcK__"